<div class="souffleur" (click)="onClick()">
  
    <audio>{{audioStrm}}</audio>

    <i class="material-icons">volume_up</i> {{ 'CONTEXTMENU.PRONOUNCE' | translate }}


  
</div>